'use strict';

(function(_) {
  window.atex = window.atex || {};
  window.atex.act = window.atex.act || {};

  /**
   * The default Notification object used as base when creating new ones.
   * Has default values for most properties.
   */
  var defaultNotification = {
    type: 'error',
    message: 'An event has occured!',
    persistent: false,
    notifications: []
  };

  /**
   * Creates a new Notification object.
   *
   * Argument 'notificationInformationObject' - An optional parameter object which contains
   * notification information. Any properties it contains will also be included in the returned
   * atex.act.Notification object.
   *
   * If 'notificationInformationObject' is not passed in, the returned atex.act.Notification
   * object will look like this:
   *
   * {
   *   "date": new Date(),
   *   "type": "error",
   *   "message": "An event has occured!",
   *   "persistent": false,
   *   "notifications": []
   * }
   *
   * Returns a new Notification object.
   */
  atex.act.Notification = function(notificationInformationObject) {
    var notificationObject = notificationInformationObject || {};

    return _.extend({ date: new Date() }, defaultNotification, notificationObject);
  };
})(_);
